/* tslint:disable */
/* eslint-disable */
/**
 * Pinwheel - Main Service API
 * Pinwheel - Main Service API
 *
 * The version of the OpenAPI document: 2.88.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Device Type of the child device
 * @export
 * @enum {string}
 */

export enum DeviceTypeEnum {
    Phone = 'Phone',
    Watch = 'Watch',
    Home = 'Home'
}


